// Modified by AI on 05/29/2026. Edit #1.
import {
    format as fnsFormat,
    isAfter as fnsIsAfter,
    isValid as fnsIsValid,
    parseISO,
    differenceInMilliseconds,
    startOfISOWeek,
    endOfISOWeek,
    getUnixTime,
    subDays,
    min as fnsMin,
    startOfDay,
} from 'date-fns';

const MOMENT_TO_FNS_FORMAT = {
    'MM/DD/YY': 'MM/dd/yy',
    'MM/DD/YYYY': 'MM/dd/yyyy',
    'M/D/YYYY HH:mm': 'M/d/yyyy HH:mm',
    'MM/DD/YYYY HH:mm': 'MM/dd/yyyy HH:mm',
    'MMM DD, YYYY': 'MMM dd, yyyy',
    'MMMM Do YYYY': 'MMMM do yyyy',
    'MM/DD/YY HH:mm': 'MM/dd/yy HH:mm',
    'DD/MM/YY': 'dd/MM/yy',
    'MM-DD-YY': 'MM-dd-yy',
    'YYYY-MM-DD': 'yyyy-MM-dd',
    MM_DD_YY: 'MM_dd_yy',
    'MMM/DD/YYYY': 'MMM/dd/yyyy',
    MMM_DD_YY_hh_mm: 'MMM_dd_yy_hh_mm',
};

// Modified by AI on 05/29/2026. Edit #1.
const toDate = (input) => {
    if (input === null || input === undefined) return new Date(NaN);
    if (input === '') return new Date(NaN);
    if (input instanceof Date) return input;
    if (typeof input === 'number') return new Date(input);
    if (typeof input === 'string') {
        const parsed = parseISO(input);
        if (fnsIsValid(parsed)) return parsed;
        return new Date(input);
    }
    return new Date(input);
};

// Modified by AI on 05/29/2026. Edit #1.
const convertFormat = (momentFormat) => {
    const mapped = MOMENT_TO_FNS_FORMAT[momentFormat];
    if (mapped) return mapped;
    // Generic token translation for unmapped formats
    return momentFormat
        .replace(/YYYY/g, 'yyyy')
        .replace(/YY/g, 'yy')
        .replace(/Do/g, 'do')
        .replace(/DD/g, 'dd')
        .replace(/D/g, 'd');
};

// Modified by AI on 05/29/2026. Edit #1.
export const formatDate = (date, momentFormat) => {
    const d = toDate(date);
    if (!fnsIsValid(d)) return '';
    return fnsFormat(d, convertFormat(momentFormat));
};

// Generated by AI on 05/28/2026
export const isDateAfter = (dateA, dateB, granularity) => {
    const a = toDate(dateA);
    const b = toDate(dateB);
    if (granularity === 'day') {
        return fnsIsAfter(startOfDay(a), startOfDay(b));
    }
    return fnsIsAfter(a, b);
};

// Generated by AI on 05/28/2026
export const isValidDate = (date) => {
    const d = toDate(date);
    return fnsIsValid(d);
};

// Generated by AI on 05/28/2026
export const durationAsYears = (startDate, endDate) => {
    const start = toDate(startDate);
    const end = toDate(endDate);
    const totalMs = differenceInMilliseconds(end, start);
    const msInYear = 365.25 * 24 * 60 * 60 * 1000;
    return totalMs / msInYear;
};

// Modified by AI on 05/29/2026. Edit #1.
export const durationAsMonths = (startDate, endDate) => {
    const start = toDate(startDate);
    const end = toDate(endDate);
    const totalMs = differenceInMilliseconds(end, start);
    const avgMsInMonth = 30.4375 * 24 * 60 * 60 * 1000;
    return totalMs / avgMsInMonth;
};

// Generated by AI on 05/28/2026
export const getStartOfISOWeekUnix = (date) => {
    const d = toDate(date);
    return getUnixTime(startOfISOWeek(d));
};

// Generated by AI on 05/28/2026
export const getEndOfISOWeekUnix = (date) => {
    const d = toDate(date);
    return getUnixTime(endOfISOWeek(d));
};

// Generated by AI on 05/28/2026
export const subtractDays = (date, days) => {
    const d = toDate(date);
    return subDays(d, days);
};

// Generated by AI on 05/28/2026
export const minDate = (dates) => {
    const validDates = dates.map(toDate).filter(fnsIsValid);
    if (validDates.length === 0) return null;
    return fnsMin(validDates);
};

// Generated by AI on 05/28/2026
export const formatNow = (momentFormat) => formatDate(new Date(), momentFormat);

// Generated by AI on 05/28/2026
export const subtractDaysAndFormat = (date, days, momentFormat) => {
    const d = subtractDays(date, days);
    return formatDate(d, momentFormat);
};
